import { get, post, put, patch } from "../Config"

export function SearchBusinessFeatureStory({ params = {}, lang }) {
  return get({ url: `/v1/admin/business-feature-story`, params, lang })
}
export function GetBusinessFeatureStoryById({ id, lang }) {
  return get({ url: `/v1/admin/business-feature-story/${id}`, lang })
}
export function CreateBusinessFeatureStory({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/business-feature-story`, params, data, lang })
}
export function UpdateBusinessFeatureStory({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/business-feature-story/${id}`, params, data, lang })
}
export function PatchBusinessFeatureStory({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/business-feature-story/${id}`, params, data, lang })
}
export function DeleteBusinessFeatureStory({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/business-feature-story/mutiDelete`, params, data, lang })
}
